// These code is to style the text input,
// due to the restiction of the cotnact form 7, using pure CSS not possible at he moment
(function wra_contact() {

  const inputs = document.querySelectorAll('.wpcf7-form input:not([type="submit"])');
  const CSS_CLASS_FLOATING_LABEL = 'floating-label';
  const CSS_CLASS_FOCUS_LABEL = 'focus-label';

  function wra_handleInputBlur($target) {
    const $label = $target.parentNode.previousElementSibling;
    if (!$label) {
      return;
    }

    if ($target.value.length > 0) {
      $label.classList.add(CSS_CLASS_FLOATING_LABEL);
      $label.classList.remove(CSS_CLASS_FOCUS_LABEL);
    } else {
      $label.classList.remove(CSS_CLASS_FLOATING_LABEL);
      $label.classList.remove(CSS_CLASS_FOCUS_LABEL);
    }
  }

  inputs.forEach($input => {
    if ($input.type !== 'hidden') {
      wra_handleInputBlur($input);
      $input.addEventListener('focus', (e) => {
        const label = e.target.parentNode.previousElementSibling;
        label.classList.add(CSS_CLASS_FLOATING_LABEL);
        label.classList.add(CSS_CLASS_FOCUS_LABEL);
      });
      $input.addEventListener('blur', e => wra_handleInputBlur(e.target));
    }
  });
}());
